module.exports = __webpack_public_path__ + "img/mingrensheying.42ea018c.png";